/** @jsx jsx */
import { type SerializedStyles, css, jsx } from '@emotion/react';

import type { ReactNode } from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  root: css`
    margin-bottom: var(--cds-spacing-150);
  `,
};

type Props = {
  showPageTitleHeadingSize?: boolean;
  additionalStyles?: SerializedStyles;
  children: ReactNode;
};

const SectionHeadingComponent = (props: Props) => {
  const { children, additionalStyles, showPageTitleHeadingSize = false } = props;
  return (
    <Typography2
      component={showPageTitleHeadingSize ? 'h1' : 'h2'}
      variant={showPageTitleHeadingSize ? 'titleMedium' : 'subtitleLarge'}
      css={[styles.root, additionalStyles]}
    >
      {children}
    </Typography2>
  );
};

export default SectionHeadingComponent;
